var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "panel-tag mt-2" }, [
      _vm._v(
        "\n        " + _vm._s(_vm.__t("EXPIRENZA_LOCATION_PARAMS")) + "\n    "
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "glovo_location_auth" },
      [
        _c("b-overlay", { attrs: { show: _vm.is_load_connect } }, [
          _c("div", { staticClass: "form-group mt-2" }, [
            _c(
              "label",
              { staticClass: "form-label", attrs: { for: "glovo_username" } },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.__t("EXPIRENZA_USERNAME")) +
                    "\n                "
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "input-group flex-nowrap" }, [
              _c("div", { staticClass: "input-group-prepend" }, [
                _c("span", { staticClass: "input-group-text" }, [
                  _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
                ]),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.general_fields.username,
                    expression: "general_fields.username",
                  },
                ],
                staticClass: "form-control",
                attrs: { id: "glovo_username", type: "text" },
                domProps: { value: _vm.general_fields.username },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.general_fields,
                      "username",
                      $event.target.value
                    )
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group mt-2" }, [
            _c(
              "label",
              { staticClass: "form-label", attrs: { for: "glovo_password" } },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.__t("EXPIRENZA_PASSWORD")) +
                    "\n                "
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "input-group flex-nowrap" }, [
              _c("div", { staticClass: "input-group-prepend" }, [
                _c("span", { staticClass: "input-group-text" }, [
                  _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
                ]),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.general_fields.password,
                    expression: "general_fields.password",
                  },
                ],
                staticClass: "form-control",
                attrs: { id: "glovo_password", type: "text" },
                domProps: { value: _vm.general_fields.password },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.general_fields,
                      "password",
                      $event.target.value
                    )
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-outline-success waves-effect waves-themed",
              attrs: { type: "button" },
              on: { click: _vm.get_locations },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.__t("CONNECT")) +
                  "\n            "
              ),
            ]
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-group mt-4 pt-4 mb-4 pb-4" },
      [
        _c("b-overlay", { attrs: { show: _vm.is_load } }, [
          _c(
            "label",
            { staticClass: "form-label", attrs: { for: "glovo_location" } },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.__t("GLOVO_REST")) +
                  "*\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _vm.ext_restaurants.length > 0
            ? _c(
                "div",
                {},
                [
                  _c("v-select", {
                    staticClass: "imc_reasons",
                    attrs: {
                      reduce: function (item) {
                        return String(item.provider_id)
                      },
                      label: "provider_name",
                      filter: _vm.searchRest,
                      options: this.ext_restaurants,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "option",
                          fn: function (option) {
                            return [
                              _c("div", { staticClass: "d-center" }, [
                                _c("div", [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(option.provider_id) +
                                      " - " +
                                      _vm._s(option.provider_name) +
                                      "\n                            "
                                  ),
                                ]),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1217533938
                    ),
                    model: {
                      value: _vm.general_fields.store_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.general_fields, "store_id", $$v)
                      },
                      expression: "general_fields.store_id",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }